var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import ReactSelect from "react-select";
import styled from "styled-components";
export var selectMenusZIndex = 100;
var makeCustomTheme = function (theme) { return function (selectTheme) {
    return __assign(__assign({}, selectTheme), { borderRadius: 4, colors: __assign(__assign({}, selectTheme.colors), { primary: theme.colors.border, primary25: theme.colors.selected, primary50: theme.colors.border, primary75: theme.colors.tooltip, danger: theme.colors.text, dangerLight: theme.colors.border, neutral0: theme.colors.mainBackground, neutral5: theme.colors.mainBackgroundDisabled, neutral30: theme.colors.controlFocused, neutral60: theme.colors.border, neutral80: theme.colors.text, neutral10: theme.colors.border, neutral20: theme.colors.border }) });
}; };
var getOptionColor = function (theme, state) {
    if (state.isDisabled)
        return theme.colors.border;
    if (state.isSelected)
        return theme.colors.bright;
    return theme.colors.text;
};
var makeCustomStyles = function (theme, providedStyles) { return (__assign({ option: function (styles, state) { return (__assign(__assign({}, styles), { color: getOptionColor(theme, state) })); }, control: function (styles) { return (__assign(__assign({}, styles), { minWidth: 160 })); }, menu: function (styles) { return (__assign(__assign({}, styles), { zIndex: selectMenusZIndex })); }, multiValueLabel: function (styles, control) { return (__assign(__assign({}, styles), { paddingRight: control.data.isDisabled ? "8px" : "", borderRadius: "2px 0 0 2px", backgroundColor: theme.colors.disabled })); }, multiValueRemove: function (styles, control) {
        return control.data.isDisabled
            ? __assign(__assign({}, styles), { display: "none" }) : __assign(__assign({}, styles), { color: theme.colors.text, borderRadius: "0 2px 2px 0", background: theme.colors.disabled, ":hover": {
                background: theme.colors.borderSecondary,
            } });
    } }, providedStyles)); };
export var Select = styled(ReactSelect).attrs(function (props) { return (__assign(__assign({}, props), { theme: makeCustomTheme(props.theme), styles: makeCustomStyles(props.theme, props.styles) })); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
